import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loading: false,
    appointments: [],
    aptStatus: [],
    aptList: [],
    appointmentlist: [],
    error: "",
    count: 0,
    currentAppointment: null,
    currentCallType: null,
    appointmentState: null,
    ongoingAppointmentId: null,
    isInAppointment: false,
}

const appointmentSlice = createSlice({
    name: "appointments",
    initialState,
    reducers: {
        updateAptStatus: (state, action) => {
            state.aptStatus = action.payload
        },
        updateAppointmentsLoading: (state, action) => {
            state.loading = action.payload
        },
        updateAppointmentList: (state, action) => {
            state.appointments = action.payload
        },
        showAppointmentListing: (state, action) => {
            state.appointmentlist = action.payload
        },
        updateCurrentAppointment: (state, action) => {
            state.currentAppointment = action.payload
        },
        updateCurrentCallType: (state, action) => {
            state.callType = action.payload
        },
        updateAppointmentState: (state, action) => {
            state.appointmentState = action.payload
        },
        updateOngoingAppointmentId: (state, action) => {
            state.ongoingAppointmentId = action.payload
        },
        updateIsInAppointment: (state, action) => {
            state.isInAppointment = action.payload
        }
    },
})

export const {
    updateAptStatus,
    updateAppointmentList,
    updateAppointmentsLoading,
    showAppointmentListing,
    updateCurrentAppointment,
    updateCurrentCallType,
    updateOngoingAppointmentId,
    updateIsInAppointment
} = appointmentSlice.actions

export default appointmentSlice.reducer
